import router from './router'

export default {
	moduleName: 'column',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/column/index.js